import React from 'react';

import { leftPadNumber } from '@pkg/utils';

import { Number, StyledNumberCounter, Value } from './styles';

export interface NumberCounterProps {
    value?: number;
    leftPad?: number;
    monospace?: boolean;
    // TODO: It would be preferably to allow `fontSize`
    // to be controlled/styled by the consumer.
    compact?: boolean;
}

// TODO: This component is intended to become a "basic Odometer".
// That functionality has not yet been built.
export function NumberCounter({ value = 0, leftPad = 0, monospace = false, compact = false }: NumberCounterProps) {
    const formattedValue = leftPadNumber(value, { padding: leftPad });
    const characters = [...formattedValue].map((character, index) => (
        <Number key={`NumberCounter-Number-${character}-${index}`}>{character}</Number>
    ));

    return (
        <StyledNumberCounter $monospace={monospace} $compact={compact}>
            <Value>{characters}</Value>
        </StyledNumberCounter>
    );
}
